var styles = {"button":"Collapsible-module_button__3mtfz","caret":"Collapsible-module_caret__2B7yN","buttonExpanded":"Collapsible-module_buttonExpanded__1ZuCQ","content":"Collapsible-module_content__2jYwh","contentExpanded":"Collapsible-module_contentExpanded__2H7Kj"};

export { styles as default };
//# sourceMappingURL=Collapsible.module.css.js.map
